import { IonDate } from '../components/IonDate';
const CheckNotNull = Symbol('CheckNotNull');

class EventFee {
    public event_feeID: string = '';
    public eventID: string = '';
    public member_typeID: string = '';
    public early_bird_rate: number = 0;
    public normal_rate: number = 0;
    public group_discount_rate: number = 0;
    public early_bird_group_discount_rate: number = 0;
    public min_group_discount_pax: number = 0;
    public creatorID: string = '';
    public updaterID: string = '';
    public datetime_created: Date | null = null;
    public datetime_updated: Date | null = null;

    constructor(
        event_feeID: string,
        eventID: string,
        member_typeID: string,
        early_bird_rate: string,
        normal_rate: string,
        group_discount_rate: string,
        early_bird_group_discount_rate: string,
        min_group_discount_pax: string,
        creatorID: string,
        updaterID: string,
        datetime_created: string,
        datetime_updated: string
    ) {
        this.event_feeID = this[CheckNotNull](event_feeID) ? event_feeID : '';
        this.eventID = this[CheckNotNull](eventID) ? eventID : '';
        this.member_typeID = this[CheckNotNull](member_typeID) ? member_typeID : '';
        this.early_bird_rate = this[CheckNotNull](early_bird_rate) ? parseFloat(early_bird_rate) : 0;
        this.normal_rate = this[CheckNotNull](normal_rate) ? parseFloat(normal_rate) : 0;
        this.group_discount_rate = this[CheckNotNull](group_discount_rate) ? parseFloat(group_discount_rate) : 0;
        this.early_bird_group_discount_rate = this[CheckNotNull](early_bird_group_discount_rate) ? parseFloat(early_bird_group_discount_rate) : 0,
        this.min_group_discount_pax = this[CheckNotNull](min_group_discount_pax) ? parseInt(min_group_discount_pax) : 0;
        this.creatorID = this[CheckNotNull](creatorID) ? creatorID : '';
        this.updaterID = this[CheckNotNull](updaterID) ? updaterID : '';
        this.datetime_created = this[CheckNotNull](datetime_created) ? IonDate(datetime_created) : null;
        this.datetime_updated = this[CheckNotNull](datetime_updated) ? IonDate(datetime_updated) : null;
    }
    private [CheckNotNull] = (value: string) => {
        if(value && value != null && value != 'null' && value.length > 0)
            return true;
        else
            return false;
    } 
}
export default EventFee;